// @ts-nocheck
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

export const shouldProductLoadRealTime = (product: ProductModel) => {
    return !isCustomQuoteRequired(product) && !product.isVariantParent;
};

export const shouldProductDisplayPriceAndInventory = (product: ProductModel) => {
    return shouldProductLoadRealTime(product);
};

export const isCustomQuoteRequired = (product: ProductModel) => {
    if (product.isVariantParent) {
        return false;
    }

    return (
        product.quoteRequired || // is OOTB quoteRequired flag (if they ever use it)
        ("quoteRequired" in product.properties && product.properties.quoteRequired.toLowerCase() === "true") // is custom quoteRequired
    );
};
